'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164 from "./presto.types$-Two-Factor-Auth-Name$$anon$164.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165 from "./presto.types$-Two-Factor-Auth-Name$$anon$165.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthName$() {
  this.ccg = null;
  this.cch = false;
  this.cce = null;
  this.ccf = false;
  this.cck = null;
  this.ccl = false;
  this.cci = null;
  this.ccj = false;
  this.ccm = null;
  this.ccn = false;
}
export { $c_Lpresto_types$TwoFactorAuthName$ as $c_Lpresto_types$TwoFactorAuthName$ };
$p = $c_Lpresto_types$TwoFactorAuthName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthName$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthName$() {
}
export { $h_Lpresto_types$TwoFactorAuthName$ as $h_Lpresto_types$TwoFactorAuthName$ };
$h_Lpresto_types$TwoFactorAuthName$.prototype = $p;
$p.cIy = (function() {
  if ((!this.cch)) {
    this.ccg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cch = true;
  }
  return this.ccg;
});
$p.ze = (function() {
  if ((!this.ccf)) {
    this.cce = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.ccf = true;
  }
  return this.cce;
});
$p.a2K = (function() {
  if ((!this.ccl)) {
    this.cck = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ccl = true;
  }
  return this.cck;
});
$p.csh = (function() {
  if ((!this.ccj)) {
    this.cci = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164.$c_Lpresto_types$TwoFactorAuthName$$anon$164(this);
    this.ccj = true;
  }
  return this.cci;
});
$p.a2R = (function() {
  if ((!this.ccn)) {
    this.ccm = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165.$c_Lpresto_types$TwoFactorAuthName$$anon$165(this);
    this.ccn = true;
  }
  return this.ccm;
});
var $d_Lpresto_types$TwoFactorAuthName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthName$, "presto.types$TwoFactorAuthName$", ({
  a2h: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthName$ as $d_Lpresto_types$TwoFactorAuthName$ };
var $n_Lpresto_types$TwoFactorAuthName$;
function $m_Lpresto_types$TwoFactorAuthName$() {
  if ((!$n_Lpresto_types$TwoFactorAuthName$)) {
    $n_Lpresto_types$TwoFactorAuthName$ = new $c_Lpresto_types$TwoFactorAuthName$();
  }
  return $n_Lpresto_types$TwoFactorAuthName$;
}
export { $m_Lpresto_types$TwoFactorAuthName$ as $m_Lpresto_types$TwoFactorAuthName$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Name$.js.map
